@if (pdfConverted) {
  <span>
    <ngx-extended-pdf-viewer
      [src]="pdfConverted"
      height="100vh"
      [zoom]="'auto'"
      [showFindButton]="true"
      [showPagingButtons]="true"
      [showZoomButtons]="true"
      [showPresentationModeButton]="true"
      [showOpenFileButton]="false"
      [showPrintButton]="false"
      [showDownloadButton]="false"
      [showSecondaryToolbarButton]="true"
      [showRotateButton]="true"
      [showHandToolButton]="true"
      [showScrollingButton]="true"
      [showSpreadButton]="false"
      [showPropertiesButton]="true"
      [customToolbar]="additionalButtons"
      [(page)]="currentPage"
      (pagesLoaded)="pageRendered()"
      [printResolution]="300">
    </ngx-extended-pdf-viewer>
    <ng-template #additionalButtons>
      <div id="toolbarViewer">
        <div id="toolbarViewerLeft">
          <pdf-toggle-sidebar></pdf-toggle-sidebar>
          <div class="toolbarButtonSpacer"></div>
          <pdf-find-button [showFindButton]="true" [textLayer]="true"></pdf-find-button>
          <pdf-paging-area></pdf-paging-area>
        </div>
        <div id="toolbarViewerRight">
          <pdf-presentation-mode></pdf-presentation-mode>
          <pdf-select-tool></pdf-select-tool>
          <pdf-rotate-page></pdf-rotate-page>
          <pdf-hand-tool></pdf-hand-tool>
          <pdf-toggle-secondary-toolbar></pdf-toggle-secondary-toolbar>
        </div>
        <pdf-zoom-toolbar></pdf-zoom-toolbar>
      </div>
    </ng-template>
  </span>
}
